// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const AngleOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M12.57 5.42l-7.8 12.4a.5.5 0 00.42.76h14.53","stroke-linecap":"round","stroke-width":"1.7","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M7.82 12.84c1.32.1 4.06 1.63 4.06 5.46","stroke-width":"1.7","stroke":"currentColor"}}]},"name":"angle","theme":"outlined"};

const AngleOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={AngleOutlinedSvg} />;
  AngleOutlined.displayName = 'AngleOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(AngleOutlined);
